import { render, staticRenderFns } from "./DashboardGrossProfit.vue?vue&type=template&id=59104c38&scoped=true&"
import script from "./DashboardGrossProfit.vue?vue&type=script&lang=js&"
export * from "./DashboardGrossProfit.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGrossProfit.vue?vue&type=style&index=0&id=59104c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59104c38",
  null
  
)

export default component.exports